import { render, staticRenderFns } from "./TablePieInfo.vue?vue&type=template&id=2f54dbaa&scoped=true&"
import script from "./TablePieInfo.vue?vue&type=script&lang=js&"
export * from "./TablePieInfo.vue?vue&type=script&lang=js&"
import style0 from "./TablePieInfo.vue?vue&type=style&index=0&id=2f54dbaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f54dbaa",
  null
  
)

export default component.exports